export default {
  TITLE: 'Comparación de ocupaciones',
  SUBTITLE: 'Explora y compara roles por compatibilidad de habilidades, demanda laboral y más.',
  COMPARE_BY: 'Comparar por',
  SKILL_MATCH: 'Compatibilidad de habilidades',
  GROWTH: 'Crecimiento',
  GROWTH_LAST_7_DAYS: 'Crecimiento: últimos 7 días',
  SALARY: 'Salario',
  AI_IMPACT: 'Impacto de la IA',
  OCCUPATION_DEMAND: 'Demanda ocupacional',
  AI_IMPACT_LEVEL_1: 'Bajo',
  AI_IMPACT_LEVEL_2: 'Muy bajo',
  AI_IMPACT_LEVEL_3: 'Moderado',
  AI_IMPACT_LEVEL_4: 'Alto',
  AI_IMPACT_LEVEL_5: 'Muy alto',
  METRIC_SKILL_MATCH: '{{value}}% de compatibilidad',
  METRIC_GROWTH: '+{{value}}% de crecimiento',
  METRIC_SALARY_PER_YEAR: '{{value}} K al año',
  METRIC_OCCUPATION_DEMAND: '{{count}} publicaciones',
  DEMAND_LEVEL_1: 'Demanda nicho',
  DEMAND_LEVEL_2: 'Demanda moderada',
  DEMAND_LEVEL_3: 'Demanda establecida',
  DEMAND_LEVEL_4: 'Alta demanda',
  DEMAND_LEVEL_5: 'Demanda masiva',
  METRIC_DEMAND_LEVEL_FALLBACK: 'Nivel de demanda {{value}}',
  METRIC_AI_LEVEL_FALLBACK: 'Nivel {{value}}',
  QUICK_COMPARISON: 'Comparación rápida de ocupaciones',
  EXIT_COMPARISON: 'Salir de comparación',
  NO_DATA: 'Sin datos',
  NO_DATA_DESCRIPTION: 'Esta información aún no está disponible para las ocupaciones seleccionadas.',
  NO_DATA_FOR_OCCUPATION: 'No hay datos disponibles para esta ocupación',
  ERROR_TITLE: 'Datos de comparación no disponibles',
  ERROR_DESCRIPTION: 'No pudimos cargar todas las métricas de comparación. Inténtalo de nuevo más tarde.',
  SELECT_MORE_OCCUPATIONS: 'Selecciona más ocupaciones para poder compararlas lado a lado.',
  LOADING: 'Cargando comparación de ocupaciones',
  SELECT_OCCUPATION: 'Seleccionar {{occupation}} para comparar',
  CHART_ARIA_LABEL: 'Gráfico de comparación de ocupaciones',
  SELECTED_FILTER: '{{filter}} seleccionado',
};
